let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4mKxN")).then(() => parcelRequire('j2o0M'));